var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCronos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#051221"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8363 32.4055L31.1136 28.2057L28.0844 26.4498L23.8363 28.9057L19.5883 26.4498V21.55L23.8363 19.0941L28.0844 21.55L31.1136 19.8001L23.8363 15.5943L16.5531 19.8001V28.2057L23.8363 32.4055Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 15.003L23.8424 6L39.4227 15.003V33.003L23.8424 42L8.25 33.003V15.003ZM23.8424 36.6658L34.8065 30.3359V17.6641L23.8424 11.3342L12.8722 17.6641V30.3359L23.8424 36.6658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronos);
export default __webpack_public_path__ + "static/media/cronos.a8e466d76309b15c7fdbb61acbedb2a2.svg";
export { ForwardRef as ReactComponent };